import React from "react";

import PropTypes from "prop-types";
import Spin from "shared/components/Spin";
import ChevronDown from "shared/components/SVG/ChevronDown";

import { COLORS } from "../../style/colors";

import "./styles.scss";

const More = ({ visible, onClick, title, loading }) => (
  <div className={"more"} onClick={onClick}>
    {loading ? (
      <Spin />
    ) : (
      <>
        {visible && (
          <>
            <p>{title}</p>
            <ChevronDown color={COLORS.CHRYSOPRASE_MEDIUM} size={16} />
          </>
        )}
      </>
    )}
  </div>
);

More.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.bool,
  visible: PropTypes.bool,
};

More.defaultProps = {
  onClick: () => {},
  visible: true,
};

export default More;
